"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Emote = void 0;
const definables_1 = require("definables");
class Emote extends definables_1.Definable {
    constructor(options) {
        var _a;
        super(options.id);
        this._backgroundImagePath = options.definition.backgroundImagePath;
        this._foregroundImagePath = options.definition.foregroundImagePath;
        this._order = options.definition.order;
        this._requiresSubscription =
            (_a = options.definition.requiresSubscription) !== null && _a !== void 0 ? _a : false;
    }
    get backgroundImagePath() {
        return this._backgroundImagePath;
    }
    get foregroundImagePath() {
        if (typeof this._foregroundImagePath !== "undefined") {
            return this._foregroundImagePath;
        }
        throw new Error(this.getAccessorErrorMessage("foregroundImagePath"));
    }
    get order() {
        return this._order;
    }
    get requiresSubscription() {
        return this._requiresSubscription;
    }
    hasForegroundImagePath() {
        return typeof this._foregroundImagePath !== "undefined";
    }
}
exports.Emote = Emote;
